import {ModuleWithProviders} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';

import {HomeComponent} from './home.component';
import {SignInComponent} from './signin.component';
import {SignUpComponent} from './signup.component';
import {ConfirmComponent} from "./confirm.component";
import {ForgotComponent} from "./forgot.component";
import {AuthGuard} from "./auth/auth.guard";

const appRoutes: Routes = [
    {
        path: '',
        component: HomeComponent,
        pathMatch: 'full',
        canActivate: [AuthGuard]
    },
    {
        path: 'signin',
        component: SignInComponent
    },
    {
        path: 'signup',
        component: SignUpComponent
    },
    {
        path: 'confirm',
        component: ConfirmComponent
    },
    {
        path: 'forgot',
        component: ForgotComponent
    }

];

export const appRoutingProviders: any[] = [];

export const routing: ModuleWithProviders = RouterModule.forRoot(appRoutes);


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/app/app.routing.ts